import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import '../styles/route.css';

const NotFoundPage: React.FC = () => {
  return (
    <div className="landing-shell">
      <Header />
      <main>
        <section className="sw-section sw-404">
          <div className="container">
            {/* Mono, because a status code is a figure. */}
            <span className="sw-404-code">404</span>
            <h1>This route doesn&apos;t exist.</h1>
            <p>
              The page you&apos;re after has moved or was never here. Let&apos;s get you back on
              the road.
            </p>
            <Link className="sw-btn-primary" to="/">
              Back to home
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default NotFoundPage;
